/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-info': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<path pid="0" d="M8.187 4.414l-3.274.41-.117.544.643.118c.42.1.503.252.412.67l-1.055 4.958C4.518 12.397 4.946 13 5.95 13c.779 0 1.684-.36 2.094-.855l.126-.595c-.286.252-.703.352-.98.352-.394 0-.537-.276-.435-.762l1.43-6.726zm.1-2.984a1.43 1.43 0 11-2.86 0 1.43 1.43 0 012.86 0z" _fill="#000"/>'
  }
})
